import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Variables } from "../../Variables1/Variables";
import validator from "validator";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Row, Col, Image, Form, Button, Spinner } from "react-bootstrap";
import { Card } from "react-bootstrap";
import { Link } from "react-router-dom";
import CustomSnipper from "../../components/customSnipper";
import Util from "../../Classes/Util";
import { getRoles } from "@testing-library/react";
import Cookies from "js-cookie";

function ManageUser(props) {
  const RouteUserId = useParams();
  const navigate = useNavigate();
  const token  = Cookies.get("token");

  const [Permissions, setPermissions] = useState(
    Util.decrypt(localStorage.getItem("rpmRRTLx12"))
  );

  const [userId, setUserId] = useState(Number(RouteUserId.RouteUserId) || 0);

  const [loader, setLoader] = useState(false);
  const [buttonLoader, setButtonLoader] = useState(false);

  const [userDetails, setUserDetails] = useState({
    UserId: 0,
    Email: "",
    FirstName: "",
    GenderId: 1,
    LastName: "",
    PhoneNumber: "",
    RoleId: "",
  });

  const [genders, setGenders] = useState([]);
  const [roles, setRoles] = useState([]);

  // Get Gender
  const GetGenders = async () => {
    let response = await fetch(Variables.API_URL + "Gender/GetGender", {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    let result = await response.json();
    if (response.status === 200) {
      setGenders(result);
    }
  };

  // Get Roles
  const GetRoles = async () => {
    let response = await fetch(Variables.API_URL + "Role/GetRoleForDropDown", {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    let result = await response.json();
    if (response.status === 200) {
      setRoles(result);
    }
  };

  // Get User Details
  const GetUserDetails = async () => {
    let response = await fetch(
      Variables.API_URL + "User/GetUserDetails/" + userId,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    let result = await response.json();
    if (response.status === 200) {
      setUserDetails(result);
    }
  };

  // handle Inputs
  const handleInputs = (e) => {
    const { name, value } = e.target;
    var element;
    if (value === "" || value === "0") {
      element = document.getElementById(name);
      element.classList.add("is-invalid");
    } else {
      element = document.getElementById(name);
      element.classList.remove("is-invalid");
    }
    setUserDetails((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  // Add new user
  const AddNewUser = async () => {
    setButtonLoader(true);
    let response = await fetch(Variables.API_URL + "User/AddNewUser", {
      method: "POST",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        UserId: userId,
        FirstName: userDetails.FirstName,
        LastName: userDetails.LastName,
        PhoneNumber: userDetails.PhoneNumber,
        Email: userDetails.Email,
        GenderId: userDetails.GenderId,
        RoleId: userDetails.RoleId,
      }),
    });
    let result = await response.json();
    if (response.status === 200) {
      toast.success(result, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      setTimeout(() => {
        navigate("/Users");
      }, 1000);
    } else {
      toast.error(result, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
    setButtonLoader(false);
  };

  // Update user
  const UpdateUser = async () => {
    setButtonLoader(true);
    let response = await fetch(Variables.API_URL + "User/UpdateUser", {
      method: "POST",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        UserId: userId,
        FirstName: userDetails.FirstName,
        LastName: userDetails.LastName,
        PhoneNumber: userDetails.PhoneNumber,
        Email: userDetails.Email,
        GenderId: userDetails.GenderId,
        RoleId: userDetails.RoleId,
      }),
    });
    let result = await response.json();
    if (response.status === 200) {
      toast.success(result, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      setTimeout(() => {
        navigate("/Users");
      }, 1000);
    } else {
      toast.error(result, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
    setButtonLoader(false);
  };

  // Check input validity
  function IsValid() {
    var hasError = false;
    var element;
    if (userDetails.FirstName === null || userDetails.FirstName === "") {
      element = document.getElementById("FirstName");
      element.classList.add("is-invalid");
      hasError = true;
    }
    if (userDetails.LastName === null || userDetails.LastName === "") {
      element = document.getElementById("LastName");
      element.classList.add("is-invalid");
      hasError = true;
    }
    if (
      userDetails.GenderId === null ||
      userDetails.GenderId === "0" ||
      userDetails.GenderId === 0
    ) {
      element = document.getElementById("GenderId");
      element.classList.add("is-invalid");
      hasError = true;
    }
    if (
      userDetails.RoleId === null ||
      userDetails.RoleId === "0" ||
      userDetails.RoleId === 0
    ) {
      element = document.getElementById("RoleId");
      element.classList.add("is-invalid");
      hasError = true;
    }
    if (
      userDetails.Email === null ||
      userDetails.Email === "" ||
      validator.isEmail(userDetails.Email) === false
    ) {
      element = document.getElementById("Email");
      element.classList.add("is-invalid");
      hasError = true;
    }
    if (userDetails.PhoneNumber === null || userDetails.PhoneNumber === "") {
      element = document.getElementById("PhoneNumber");
      element.classList.add("is-invalid");
      hasError = true;
    }
    if (hasError === true) {
      return false;
    } else {
      return true;
    }
  }

  // handle submit
  const HandleSubmit = () => {
    var isValid = IsValid();
    if (isValid) {
      // case of insert
      if (userId === 0) {
        AddNewUser();
      }
      // case of update
      else {
        UpdateUser();
      }
    } else {
      toast.error("Please fill all required fields", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  };

  useEffect(() => {
   
   
         GetGenders();
    GetRoles();
    if (userId != 0) {
      GetUserDetails();
    }
 
  }, [userId]);

  return (
    <div>
      <Row>
        <Col xl="12" lg="12">
          <Card>
            <Card.Header className="d-flex justify-content-between">
              <div className="header-title">
                <h4 className="card-title">
                  {userId === 0
                    ? "New User Information"
                    : "Update User Information"}
                </h4>
              </div>
            </Card.Header>
            {loader === true ? <CustomSnipper /> : ""}
            <Card.Body>
              <div className="new-user-info">
                <form>
                  <div className="row">
                    <Form.Group className="col-md-6 form-group">
                      <Form.Label htmlFor="fname">First Name:</Form.Label>
                      <Form.Control
                        id="FirstName"
                        name="FirstName"
                        placeholder="First Name"
                        type="text"
                        value={userDetails.FirstName}
                        onChange={handleInputs}
                      />
                    </Form.Group>

                    <Form.Group className="col-md-6 form-group">
                      <Form.Label htmlFor="lname">Last Name:</Form.Label>
                      <Form.Control
                        id="LastName"
                        name="LastName"
                        placeholder="Last Name"
                        type="text"
                        value={userDetails.LastName}
                        onChange={handleInputs}
                      />
                    </Form.Group>

                    {/* <Form.Group className="col-sm-6 form-group">
                      <Form.Label>Gender:</Form.Label>
                      <select
                        className="selectpicker form-control"
                        data-style="py-0"
                        name="GenderId"
                        id="GenderId"
                        value={userDetails.GenderId}
                        onChange={handleInputs}
                      >
                        <option key={0} value={0}>
                          -- Select --
                        </option>
                        {genders.map((x) => {
                          return (
                            <option key={x.GenderId} value={x.GenderId}>
                              {x.GenderName}
                            </option>
                          );
                        })}
                      </select>
                    </Form.Group> */}

                    <Form.Group className="col-sm-6 form-group">
                      <Form.Label>Role:</Form.Label>
                      <select
                        className="selectpicker form-control"
                        data-style="py-0"
                        name="RoleId"
                        id="RoleId"
                        value={userDetails.RoleId}
                        onChange={handleInputs}
                      >
                        <option key={0} value={0}>
                          -- Select --
                        </option>
                        {roles.map((x) => {
                          return (
                            <option key={x.RoleId} value={x.RoleId}>
                              {x.RoleName}
                            </option>
                          );
                        })}
                      </select>
                    </Form.Group>

                    <Form.Group className="col-md-6  form-group">
                      <Form.Label htmlFor="email">Email:</Form.Label>
                      <Form.Control
                        disabled={userId === 0 ? false : true}
                        id="Email"
                        name="Email"
                        placeholder="Email"
                        type="text"
                        value={userDetails.Email}
                        onChange={handleInputs}
                      />
                    </Form.Group>

                    <Form.Group className="col-md-6  form-group">
                      <Form.Label htmlFor="mobno">Phone Number:</Form.Label>
                      <Form.Control
                        id="PhoneNumber"
                        name="PhoneNumber"
                        placeholder="Phone Number"
                        type="text"
                        value={userDetails.PhoneNumber}
                        onChange={handleInputs}
                      />
                    </Form.Group>
                  </div>
                </form>
              </div>
              <Row>
                <Col>
                  <Button
                    type="button"
                    variant="btn btn-primary"
                    className="float-right"
                    onClick={HandleSubmit}
                  >
                    {buttonLoader === true ? (
                      <>
                        <Spinner
                          as="span"
                          animation="border"
                          size="sm"
                          role="status"
                          aria-hidden="true"
                        />
                        <span className="visually-hidden">Loading...</span>
                      </>
                    ) : userId === 0 ? (
                      "Add New User"
                    ) : (
                      "Update User"
                    )}
                  </Button>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </Col>
      </Row>
      <ToastContainer
        position="top-right"
        autoClose={1000}
        hideProgressBar={false}
        newestOnTop={true}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </div>
  );
}

export default ManageUser;
